import React, { FC, useEffect, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import MenuIcon from '@mui/icons-material/Menu';
import DeleteIcon from '@mui/icons-material/Delete';
import Switch from '@mui/material/Switch';
import { Grid, Button, TextField, Box } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid } from '../../atomic/molecules';
import { SCUIButton } from '../../atomic/atoms';
import Swal from 'sweetalert2';
import { MobilePanelAppQuery } from '../../services/query';
import MobileAppHandlerCommand from '../../services/command/mobileapphandler/MobileAppHandlerCommand.services';
import TimeHelper from '../../utils/time';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SCUIMPAppHandlerDialogV2 } from '../../atomic/molecules/SCUIMPAppHandlerDialogV2/SCUIMPAppHandlerDialogV2';
import { MPAH, mpahCls } from './mpApplicationHandlerV2.classes';

export const MpApplicationHandlerV2: FC<any> = () => {
    const { t } = useTranslation();

    const [refresh, setRefresh] = React.useState(false);
    const [searchedMpHandlerName, setSearchedMpHandlerName] = React.useState('');
    const [searchedMpHandleList, setSearchedMpHandleList] = useState<any>();
    const [mobileAppHandler, setMobileAppHandler] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [mpApplicationHandler, setMpApplicationHandler] = React.useState<any>();

    const region = useSelector((state: any) => state.lastRegionReducer.setLastRegion);

    const refreshFunc = () => setRefresh((prevRefreshing) => !prevRefreshing);

    const getMobilePanelHandler = () => {
        MobilePanelAppQuery.ListMobilePanelApplicationV2(region)
            .then((res: any) => {
                if (res) {
                    let parseData = res.model.data.map((item: any) => {
                        return {
                            id: item.id || '-',
                            name: item.name || '',
                            android_active: item.android_Active || false,
                            ios_active: item.ios_Active || false,
                            create_Date: TimeHelper.formatDateHour(item.create_Date) || '-',
                            update_Date: TimeHelper.formatDateHour(item.update_Date) || '-',
                            link: item.link || '',
                        };
                    });
                    setMobileAppHandler(parseData);
                    setSearchedMpHandleList(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    useEffect(() => {
        getMobilePanelHandler();
    }, [refresh, region]);

    const sil = async (params: any) => {
        const result = await Swal.fire({
            text: t('mobileApp.deleteHandler'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.delete'),
        });

        if (!result.isConfirmed) {
            return;
        }

        try {
            await MobileAppHandlerCommand.PostRemoveMobileAppHandler(params);
            Swal.fire('Silindi!', ' ', 'success');
            setRefresh((prevRefreshing) => !prevRefreshing);
        } catch (error: any) {
            Swal.fire('', ' ', 'error');
            console.log('Hata :>> ', error);
        }
    };

    const columns: ExtendedGridColDef[] = [
        { field: 'id', headerName: 'ID', width: 90, flex: 1, hide: true },
        {
            field: 'name',
            headerName: t('mobileApp.name'),
            width: 150,

            flex: 1,
        },
        {
            field: 'link',
            headerName: 'Link',
            width: 150,

            flex: 1,
        },
        {
            field: 'android_Active',
            headerName: 'Android',
            width: 150,
            flex: 1,
            renderCell: (params) => {
                return (
                    <div>
                        <Switch checked={params.row.android_active} />
                    </div>
                );
            },
        },
        {
            field: 'ios_Active',
            headerName: 'IOS',
            width: 110,
            flex: 1,
            renderCell: (params) => {
                return (
                    <div className={MPAH.datagridIosSwitchCell}>
                        <Switch className={MPAH.inputSwitchIos} checked={params.row.ios_active} />
                    </div>
                );
            },
        },
        {
            field: 'create_Date',
            headerName: t('mobileApp.createDate'),
            width: 160,

            flex: 1,
        },
        {
            field: 'update_Date',
            headerName: t('mobileApp.updateDate'),
            width: 160,
        },
        {
            field: 'düzenlee',
            headerName: t('general.edit'),
            width: 160,
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    setMpApplicationHandler(params.row);
                    handleClickOpen();
                };
                return (
                    <div className={MPAH.datagridEditCell}>
                        <Button className={MPAH.inputButtonRowEdit} onClick={onclick}>
                            <MenuIcon />
                        </Button>
                    </div>
                );
            },
        },
        {
            field: 'sil',
            headerName: t('general.delete'),
            width: 160,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    sil(params.id);
                };
                return (
                    <div className={MPAH.datagridDeleteCell}>
                        <Button className={MPAH.inputButtonRowDelete} onClick={onclick}>
                            <DeleteIcon />
                        </Button>
                    </div>
                );
            },
        },
    ];
    const requestSearchMpHandle = (searchedVal: any) => {
        setSearchedMpHandlerName(searchedVal.target.value);
        let filteredRoles = searchedMpHandleList.filter(
            (o: any) => o.name.toLowerCase().indexOf(searchedVal.target.value.toLowerCase()) !== -1
        );
        console.info(filteredRoles);
        setMobileAppHandler(filteredRoles);
    };

    return (
        <SCUIContent>
            <SCUIMPAppHandlerDialogV2
                selectedRow={mpApplicationHandler}
                open={open}
                onClose={handleClose}
                refresh={refreshFunc}
            />
            <Grid container direction="row" className={MPAH.page}>
                <Grid
                    className={MPAH.titleSection}
                    size={{
                        lg: 10,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <h1 className={mpahCls('headtxt', MPAH.pageTitle)}>Application Handler </h1>
                </Grid>

                <Grid
                    className={MPAH.actionsSection}
                    size={{
                        lg: 2,
                        md: 6,
                        xs: 6,
                    }}
                >
                    <SCUIButton
                        className={MPAH.inputButtonAddParameter}
                        text={t('mobileApp.addParameter')}
                        type="primary"
                        sizeType="fixed"
                        size={'m'}
                        onClick={() => {
                            setMpApplicationHandler([]);

                            handleClickOpen();
                        }}
                    />
                </Grid>
                <Grid
                    className={MPAH.filterSection}
                    sx={{ marginBottom: 1, marginTop: 1, boxShadow: 0 }}
                    size={{
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        className={MPAH.inputTextSearchName}
                        label={t('mobileApp.name')}
                        value={searchedMpHandlerName}
                        onChange={(searchVal) => requestSearchMpHandle(searchVal)}
                        fullWidth
                    />
                </Grid>
                <Grid
                    className={MPAH.gridSection}
                    size={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <Box className={MPAH.gridWrap}>
                        <SCUICustomDataGrid
                            rows={mobileAppHandler}
                            columns={columns}
                            initialState={{
                                sorting: {
                                    sortModel: [
                                        {
                                            field: 'id',
                                            sort: 'asc',
                                        },
                                    ],
                                },
                            }}
                        />
                    </Box>
                </Grid>
            </Grid>
        </SCUIContent>
    );
};
